import Select from "@/components/fields/Select";
import {useAppState} from "@/store";
import {PARKING_DISTANCES} from "@/constants";

export default function PropertyEntranceDistance({stateKey}) {
    const {state, setState} = useAppState()

    const handleChange = (v) => {
        setState((s) => {
            s[stateKey].entranceDistance = v
        })
    }

    return (
        <Select
            label={"Distance truck can park from entrance"}
            name={`${stateKey}.entranceDistance`}
            options={Object.entries(PARKING_DISTANCES).map(v => ({label: v[1], value: v[0]}))}
            value={state[stateKey]?.entranceDistance || ''}
            onChange={handleChange}
            required
        />
    )
}
